"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudentHelper = void 0;
const dp_acma_dawn_sdk_1 = require("@greatmindsorg/dp-acma-dawn-sdk");
const isNil_1 = __importDefault(require("lodash/isNil"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
class StudentHelper {
    constructor(options, retryOptions) {
        this.options = options;
        this.retryOptions = retryOptions;
        this.studentClient = dp_acma_dawn_sdk_1.StudentClient.newInstance(this.options, this.retryOptions);
    }
    async transformToStudentIds(studentIds) {
        if ((0, isNil_1.default)(studentIds) || (0, isEmpty_1.default)(studentIds))
            return [];
        return this.findStudentIds(studentIds);
    }
    async findStudentIds(studentIds) {
        const students = await this.studentClient.findByIds(studentIds);
        return students.map((student) => ({
            userId: student.userId,
            globalId: student.globalId,
        }));
    }
}
exports.StudentHelper = StudentHelper;
//# sourceMappingURL=student.helper.js.map